import { Component, forwardRef, Output, EventEmitter, Input, inject, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbCalendar, NgbDate, NgbDateAdapter, NgbDateNativeAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DatepickerComponent),
            multi: true
        }
    ],
    standalone: false
})
export class DatepickerComponent implements ControlValueAccessor, OnInit {
  private calendar = inject(NgbCalendar);
  private dateAdapter = inject<NgbDateAdapter<NgbDateStruct>>(NgbDateAdapter);
  private ngbDateNativeAdapter = inject(NgbDateNativeAdapter);

  model?: NgbDateStruct | null;
  @Output() datechange = new EventEmitter<any>();
  @Input() placeholder = 'yyyy-mm-dd';
  @Input() disabled = false;
  @Input() defaultDate = false;
  @Input() resetOption = false;

  ngOnInit(): void {
    if (this.defaultDate) {
      this.setToday();
    }
  }

  onChange = (_: any) => { /* empty */ };
  onTouched = () => { /* empty */ };

  writeValue(obj: Date): void {
    if (obj) {
      const ngbDate = this.ngbDateNativeAdapter.fromModel(new Date(obj));
      if (ngbDate) {
        this.model = this.dateAdapter.toModel(ngbDate);
      }
    } else {
      this.model = null;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setToday(): void {
    this.model = this.dateAdapter.toModel(this.calendar.getToday());
  }

  onDateSelection(date: NgbDate): void {
    const jsDate = this.ngbDateNativeAdapter.toModel(date);
    this.onChange(jsDate);
    this.datechange.emit(jsDate);
    this.onTouched();
  }

  private getNgbDateFromModel(date: NgbDateStruct): NgbDate {
    return new NgbDate(date.year, date.month, date.day);
  }
}


